import { CORE_PATH } from '@shared/api/paths';

export const MAIN_PATH = 'OsiAccounts';

export const path = `${CORE_PATH}/${MAIN_PATH}`;
